import { render, staticRenderFns } from "./scopecity-add-or-update.vue?vue&type=template&id=d8659c4c&"
import script from "./scopecity-add-or-update.vue?vue&type=script&lang=js&"
export * from "./scopecity-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports